module.exports = __webpack_public_path__ + "static/media/papa_mit_kids.77112b5f.jpg";